import { renderElement } from "../../utils/use-render.js";
import { forwardRef } from "react";
//#region src/ui/time/separator.tsx
/**
* Divider between time values. Hidden from screen readers.
*
* @example
*   ```tsx
*   <Time.Separator />
*   <Time.Separator> of </Time.Separator>
*   ```;
*/
const Separator = forwardRef(function Separator(componentProps, forwardedRef) {
	const { render, className, style, children = "/", ...elementProps } = componentProps;
	return renderElement("span", {
		render,
		className,
		style
	}, {
		state: {},
		ref: [forwardedRef],
		props: [{
			"aria-hidden": "true",
			children
		}, elementProps]
	});
});
//#endregion
export { Separator };

//# sourceMappingURL=separator.js.map